export enum PendingPartsConsolidatedTypes {
    //Grid
    GET_PENDING_PARTS_CONSOLIDATED_LIST_LOADING = "@@pendingpartsconsolidated/GET_PENDING_PARTS_CONSOLIDATED_LIST_LOADING",
    GET_PENDING_PARTS_CONSOLIDATED_LIST_SUCCESS = "@@pendingpartsconsolidated/GET_PENDING_PARTS_CONSOLIDATED_LIST_SUCCESS",
    GET_PENDING_PARTS_CONSOLIDATED_LIST_ERROR = "@@pendingpartsconsolidated/GET_PENDING_PARTS_CONSOLIDATED_LIST_ERROR",
  }